import { Component, HostListener } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import {PlantMapService} from '../../plantmap/services/plant-map.service';
import {PlantmapPaymentComponent} from '../../plantmap/components/payment.component';

// Page created by Kowsalya

@Component({
	selector: 'payment-tnc',
	templateUrl: 'payment-tnc.component.html'
})
export class paymentTnCComponent {

    vShow : boolean;
    showAgreeBtn : boolean = true;
    constructor(
        private _layoutService: LayoutService,
        private _pageNavigationService: PageNavigationService,
        private _PlantMapService: PlantMapService,
        private _PlantmapPaymentComponent: PlantmapPaymentComponent
	){}
    
    @HostListener("window:scroll", ["$event"])
    onWindowScroll() {
        let elem = document.getElementById("style-2");
        let pos = elem.scrollTop + elem.offsetHeight;  
        console.log(pos);
        pos = Math.floor(pos);
        let max = elem.scrollHeight;
         if (pos == max) {
            this.showAgreeBtn = false;
        }
        else{
            this.showAgreeBtn = true;
        }
    }
    ngOnInit(){
        this._layoutService.setCurrentPage('payment-tnc');
        
    }
    tncClose()
    {
        this._PlantmapPaymentComponent.vShow = false;
        this._layoutService.vLayoutState.appPPMFlowHeader = true;
    }
    submitPayment()
    {
        this._PlantmapPaymentComponent.vShow = false;
        this._layoutService.vLayoutState.appPPMFlowHeader = true;
        this._PlantMapService.submitPayment();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/configuration/payment-tnc.component.ts